import _ from 'lodash';
import { i18n } from './i18n';
import pluralize from 'pluralize';
import { TAG_TYPE } from '@/constants';

export const itemLabel = (item) => {
  return getLabel({ item, v: { extra: { model_name: item.cn } } })
}

const getLabel = ({ item, v }) => {
  if (v.extra.model_name === 'User') {
    return _.get(item, 'profile.name')
  } else if ((v.extra.model_name === 'AdminUser')) {
    if (item.role.kind === 'application') {
      return `总管理员（${item.email}）`
    } else {
      return _.get(item, 'user.profile.name')
    }
  } else if ((v.extra.model_name === 'Product')) {
    return item.style_number
  } else if ((v.extra.model_name === 'OrderCuttingDate')) {
    return item.date
  } else if ((v.extra.model_name === 'Order')) {
    return item.number
  } else if ((v.extra.model_name === 'Project')) {
    return item.name
  } else if ((v.extra.model_name === 'Company')) {
    return item.name
  } else if ((v.extra.model_name === 'ProductDesign')) {
    return item.number
  } else {
    return item[v.extra.display_column]
  }
}

const linkTo = ({ item, v }) => {
  if ((v.extra.model_name === 'AdminUser')) {
    return { name: 'users.show', params: { id: item.user_id } }
  } else {
    return { name: `${pluralize(_.snakeCase(v.extra.model_name))}.show`, params: { id: item.id } }
  }
}

export const getUserLink = (h, { item }) => {
  const baseLink = <bean-link keepNode to={{ name: 'users.show', params: { id: item.id } }}>{item.profile.name}</bean-link>;

  // 如果是销售员且有项目或主管信息，显示额外信息
  if (item.role === 'salesman' && (item.sales_director || (item.projects && item.projects.length > 0))) {
    if (item.projects && item.projects.length > 0) {
      return (
        <span>
          {baseLink}
          （项目：{item.projects.map(p => <bean-link keepNode to={{ name: 'projects.show', params: { id: p.id } }}>{p.name}</bean-link>).reduce((prev, curr) => [prev, '，', curr])}）
        </span>
      );
    } else if (item.sales_director) {
      return (
        <span>
          {baseLink}
          （主管：<bean-link keepNode to={{ name: 'users.show', params: { id: item.sales_director.id } }}>{item.sales_director.profile.name}</bean-link>）
        </span>
      );
    }
  }

  return baseLink;
}

const beanLinkText = (object) => {
  return getLabel({ item: object, v: { extra: { model_name: object.cn } } })
}

const beanLink = (h, object) => {
  const extra = { model_name: object.cn }

  return <bean-link keepNode to={linkTo({ item: object, v: { extra: extra } })} >{beanLinkText(object)}</bean-link>
}

const components = {
  id: function() {
    return {
      width: 80
    }
  },
  type: function({ v }) {
    return {
      renderCell: (h, { props: { value } }) => {
        return <span>{i18n.t(`${_.map(v.model_name.split('::'), str => _.camelCase(str)).join('/')}.types.${value}`)}</span>;
      },
    }
  },
  attached: function({ v }) {
    const width = _.get(v, 'extra.type') === 'audio' ? 200 : 120

    return {
      width: width,
      renderCell: 'storageAttachment',
    }
  },
  belongsTo: function({ v }) {
    return {
      minWidth: 100,
      renderCell: (h, { props: { value } }) => {
        if (value) {
          if ((v.extra.model_name === 'User') && value.role === 'salesman' && (value.sales_director || value.project)) {
            if (value.project) {
              return <span>{beanLink(h, value)}（项目：{beanLink(h, value.project)}）</span>
            } else {
              return <span>{beanLink(h, value)}（主管：{beanLink(h, value.sales_director)}）</span>
            }
          } else {
            return <bean-link keepNode to={linkTo({ item: value, v })}>{getLabel({ item: value, v })}</bean-link>
          }
        } else {
          return <span>/</span>
        }
      },
    }
  },
  hasMany: function({ v }) {
    return {
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => <div><bean-link keepNode to={linkTo({ item: object, v })}>{getLabel({ item: object, v })}</bean-link></div>)
        } else {
          return <span>/</span>
        }
      }
    }
  },
  enum: function({ k, v }) {
    return {
      minWidth: 100,
      renderCell: (h, { props: { scope: { row } } }) => {
        if (!row[k]) {
          return <span>/</span>
        }
        return <el-tag type={TAG_TYPE[row[k]]}>{i18n.t(`${pluralize(v.label_key_path)}.${row[k]}`)}</el-tag>;
      },
    }
  },
  string: function() {
    return {
      minWidth: 100
    }
  },
  integer: function () {
    return {
      minWidth: 80
    }
  },
  decimal: function () {
    return {
      minWidth: 80
    }
  },
  float: function () {
    return {
      minWidth: 80
    }
  },
  text: function () {
    return {
      renderCell: (h, { props: { value } }) => {
        if (!value) {
          return '<span>/</span>'
        }
        return <span style="white-space: pre-wrap; word-break: break-all">{value}</span>
      },
    }
  },
  boolean: function () {
    return {
      renderCell: (h, { props: { value } }) => {
        if (value === null) {
          return <span></span>
        } else if (value) {
          return <el-tag type='success'>{i18n.t('bean.yes')}</el-tag>
        } else {
          return <el-tag type='danger'>{i18n.t('bean.no')}</el-tag>
        }
      }
    }
  },
  date: function () {
    return {
      minWidth: 100,
      renderCell: 'date'
    }
  },
  time: function () {
    return {
      renderCell: 'time'
    }
  },
  datetime: function () {
    return {
      minWidth: 135,
      renderCell: 'time',
    }
  },
  tag: function() {
    return {
      minWidth: 150,
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => <el-tag style={{ 'margin-right': '3px' }}>{object}</el-tag>)
        } else {
          return <span>/</span>
        }
      },
    }
  }
}

export default function(columns) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (v.column_type && components[_.camelCase(v.column_type)]) {
      hash[k] = _.merge({
        prop: v.prop || k,
        label: i18n.t(v.label_key_path),
      }, components[_.camelCase(v.column_type)]({ k, v }))
    } else {
      components.string()
    }
  })

  return hash
}
